<template>
  <div class="card">

    <h3 class="title">Facturación – Requerimientos Adjudicados</h3>
    <v-row v-if="esAdmin" class="mb-4">

      <v-col cols="12" md="4">
        <v-select
          v-model="filtros.contratista"
          :items="listaContratistas"
          label="contratista"
          clearable
          dense
          outlined
        />
      </v-col>
      
      <v-col cols="12" md="4">
        <v-select
          v-model="filtros.proveedor"
          :items="listaProveedores"
          label="Empresa postulante"
          clearable
          dense
          outlined
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          v-model="filtros.estado"
          :items="listarEstados"
          label="Estado"
          clearable
          dense
          outlined
        />
      </v-col>

    </v-row>
    <!-- TABLA -->
    <table class="table">
      <thead>
        <tr>
          <th>Requerimiento</th>
          <th>Facturas</th>
          <th>Acción</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="item in postulacionesAdjudicadas"
          :key="item.idpostulacion"
        >
          <!-- REQUERIMIENTO -->
          <td>
            <div class="req-title">
              <strong>{{ item.denominacion.slice(0, 3) }}</strong>
              <span class="grey--text"> - {{ item.empresa_contacto }}</span>
              <v-chip x-small class="ml-1">
                {{ item.nombre_categoria }}
              </v-chip>
            </div>
            <div class="req-subtitle">
              <span class="grey--text">{{ detallesTextoServicio(item.detalles) }} ({{ detallesTexto(item.detalles) }})</span>
              <v-icon small class="ml-2">mdi-calendar</v-icon>
              {{ formatearFecha(item.fecha_inicio) }}
            </div>
          </td>

          <!-- FACTURAS -->
          <td>
            <div v-if="item.facturas && item.facturas.length">
              <div
                v-for="f in item.facturas"
                :key="f.id_facturacion"
                class="factura-item"
              >
                <div>
                  <b>{{ item.nombre_empresa }}</b><br>
                  <strong>{{ f.numero_factura }}</strong><br>
                  <small>{{ f.fecha_emision.split('T')[0].split('-').reverse().join('/') }}</small><br>
                  <small>Monto: {{ f.moneda === 'USD' ? '$' : 'S/' }} {{ f.monto }}</small>
                </div>

                <span
                  class="badge"
                  :class="{
                    'badge-si': f.estado_pago === 'PAGADO',
                    'badge-evaluacion': f.estado_pago !== 'PAGADO'
                  }"
                >
                  {{ f.estado_pago }}
                </span>

                
                <span
                  class="badge"
                  :class="estadoClase(f)"
                >
                  {{ estadoTexto(f) }}
                </span>

                <span
                  v-if="f.estado_pago === 'PAGADO'"
                  class="badge"
                  :class="f.confirmado_proveedor ? 'badge-si' : 'badge-evaluacion'"
                >
                  {{ f.confirmado_proveedor ? 'RECEPCIÓN CONFIRMADA' : 'PENDIENTE DE CONFIRMACIÓN' }}
                </span>

                <v-btn
                  icon
                  small
                  @click="editarFactura(item, f)"
                  :disabled="f.estado_pago === 'PAGADO'"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    f.estado_pago === 'PAGADO' &&
                    !f.confirmado_proveedor
                  "
                  small
                  color="success"
                  @click="confirmarRecepcion(f)"
                >
                  Confirmar recepción
                </v-btn>
              </div>
            </div>

            <span v-else class="text-muted">
              Sin facturas registradas
            </span>
          </td>

          <!-- ACCIÓN -->
          <td class="action-cell">
            <v-btn
              small
              color="primary"
              @click="nuevaFactura(item)"
            >
              + Factura
            </v-btn>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- MODAL FACTURA -->
    <v-dialog v-model="showFactura" max-width="500">
      <v-card>
        <v-card-title>
          {{ factura.id_facturacion ? 'Editar factura' : 'Nueva factura' }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Número de factura"
            v-model="factura.numero_factura"
            outlined
            dense
          />

          <v-text-field
            label="Fecha de emisión"
            type="date"
            v-model="factura.fecha_emision"
            outlined
            dense
          />

          <v-select
            label="Moneda"
            :items="monedas"
            item-title="text"
            item-value="value"
            v-model="factura.moneda"
            outlined dense
          />

          <v-text-field
            label="Monto"
            type="number"
            v-model.number="factura.monto"
            :prefix="factura.moneda === 'PEN' ? 'S/ ' : '$ '"
            outlined
            dense
          />

          <v-select
            label="Tiempo de pago"
            :items="plazosPago"
            item-title="text"
            item-value="value"
            v-model="factura.dias_pago"
            outlined
            dense
          />
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="showFactura = false">
            Cancelar
          </v-btn>

          <v-btn color="primary" @click="submitFactura">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      top
    >
      {{ snackbar.text }}
    </v-snackbar>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FacturacionRequerimientos',

  data () {
    return {
      postulaciones: [],
      showFactura: false,
      postulacionActual: null,
      categorias_servicios: [],

      factura: {
        id_facturacion: 0,
        numero_factura: '',
        fecha_emision: '',
        moneda: 'PEN',
        monto: null,
        dias_pago: 30,
        estado_pago: 'PENDIENTE'
      },

      monedas: [
        { text: 'Soles (PEN)', value: 'PEN' },
        { text: 'Dólares (USD)', value: 'USD' }
      ],

      snackbar: {
        show: false,
        text: '',
        color: 'success'
      },

      empresaid: null,
      filtros: {
        contratista: null,
        proveedor: null,
        estado: null
      },
      plazosPago: [
        { text: '15 días', value: 15 },
        { text: '30 días', value: 30 }
      ],
    }
  },

  computed: {
    listaContratistas() {
      return [
        ...new Set(
          this.postulacionesAdjudicadasBase.map(
            p => p.empresa_contacto
          )
        )
      ]
    },

    listaProveedores () {
      return [
        ...new Set(
          this.postulacionesAdjudicadasBase
            .map(p => p.nombre_empresa)
            .filter(Boolean)
        )
      ]
    },

    listarEstados () {
      return [
        'PAGADO',
        'PENDIENTE',
        'SIN FACTURA'
      ]
    },

    postulacionesAdjudicadasBase () {
      return this.postulaciones.filter(
        p => p.estado === 'ADJUDICADO'
      ).sort((a, b) => a.idrequerimiento - b.idrequerimiento)
    },

    postulacionesAdjudicadas () {
      return this.postulacionesAdjudicadasBase.filter(item => {

        if (
          this.filtros.contratista &&
          item.empresa_contacto !== this.filtros.contratista
        ) {
          return false
        }

        if (
            this.filtros.proveedor &&
            item.nombre_empresa !== this.filtros.proveedor
          ) {
            return false
          }

        if (this.filtros.estado) {

          if (
            this.filtros.estado === 'SIN FACTURA' &&
            (!item.facturas || !item.facturas.length)
          ) {
            return true
          }

          if (!item.facturas?.length) {
            return false
          }

          return item.facturas.some(
            f => f.estado_pago === this.filtros.estado
          )
        }

        return true
      })
    },
  },

  created () {
    this.idusuario = localStorage.getItem('idusuario')
    this.empresaid = Number(localStorage.getItem('empresa'))
    this.rol = localStorage.getItem('rol')
    this.esAdmin =
    this.rol === 'ADMINISTRADOR'
    this.cargarCategorias();
    this.listarPostulaciones()
  },

  methods: {
    async listarPostulaciones () {
      const res = await axios.get(
        'api/PostulacionEmpresas/ListarPorEmpresa/' + this.idusuario
      )
      this.postulaciones = res.data
    },

    nuevaFactura (item) {
      this.postulacionActual = item
      this.factura = {
        id_facturacion: 0,
        numero_factura: '',
        fecha_emision: '',
        moneda: 'PEN',
        monto: null,
        dias_pago: 30,
        estado_pago: 'PENDIENTE'
      }
      this.showFactura = true
    },

    editarFactura (item, f) {
      this.postulacionActual = item
      this.factura = {
        id_facturacion: f.id_facturacion,
        numero_factura: f.numero_factura,
        fecha_emision: f.fecha_emision.split('T')[0],
        moneda: f.moneda,
        monto: f.monto,
        dias_pago: f.dias_pago || 15,
        estado_pago: f.estado_pago
      }
      this.showFactura = true
    },

    async cargarCategorias() {
      try {
        const response = await axios.get("/api/CategoriaServicios/Listar");
        this.categorias_servicios = response.data;
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    },
    nombreRubro (idRubro) {
      // console.log(this.categorias_servicios)
      const rubro = this.categorias_servicios.find(
        c => c.id === idRubro
      )
      return rubro ? rubro.nombrecategoria : '—'
    },

    submitFactura () {
      if (!this.factura.numero_factura) {
        this.snackbar = {
          show: true,
          text: 'Ingrese número de factura',
          color: 'error'
        }
        return
      }

      if (!this.factura.fecha_emision) {
        this.snackbar = {
          show: true,
          text: 'Ingrese fecha de emisión',
          color: 'error'
        }
        return
      }

      if (!this.factura.monto) {
        this.snackbar = {
          show: true,
          text: 'Ingrese monto',
          color: 'error'
        }
        return
      }
      if (this.factura.id_facturacion) {
        this.actualizarFactura()
      } else {
        this.guardarFactura()
      }
    },

    guardarFactura () {
      axios.post('api/FacturacionRequerimientos/Crear', {
        ...this.factura,
        idrequerimiento: this.postulacionActual.idrequerimiento,
        id_empresa: this.empresaid
      }).then(() => {
        this.showFactura = false
        this.snackbar = {
          show: true,
          text: 'Factura registrada correctamente',
          color: 'success'
        }
        this.listarPostulaciones()
      }).catch((err) => {
        console.error(err)
        this.snackbar = {
          show: true,
          text: err.response?.data?.message || 'Error al guardar factura',
          color: 'error'
        }
      })
    },

    actualizarFactura () {
      axios.put('api/FacturacionRequerimientos/Actualizar', {
        ...this.factura,
        idrequerimiento: this.postulacionActual.idrequerimiento,
        id_empresa: this.empresaid
      }).then(() => {
        this.showFactura = false
        this.snackbar = {
          show: true,
          text: 'Factura actualizada correctamente',
          color: 'success'
        }
        this.listarPostulaciones()
      }).catch(() => {
        this.snackbar = {
          show: true,
          text: 'Error al actualizar factura',
          color: 'error'
        }
      })
    },
    detallesTexto(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.detalle).join(', ')
    },
    detallesTextoServicio(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.servicio).join(', ')
    },
    formatearFecha(fecha){
      if(!fecha) return ''
      return new Date(fecha).toLocaleDateString()
    },
    diasTranscurridos (fecha) {
      // console.log(fecha)
      const hoy = new Date()
      const emision = new Date(fecha)
      return Math.floor((hoy - emision) / (1000 * 60 * 60 * 24))
    },
    // estadoClase (f) {
    //   if (f.estado_pago === 'PAGADO') return 'badge-verde'
    //   const d = this.diasTranscurridos(f.fecha_emision)
    //   if (d >= 30) return 'badge-rojo'
    //   if (d >= 15) return 'badge-amarillo'
    //   return 'badge-verde'
    // },

    // estadoTexto (f) {
    //   // console.log(f)
    //   if (f.estado_pago === 'PAGADO') return 'PAGADO'
    //   const d = this.diasTranscurridos(f.fecha_emision)
    //   if (d >= 30) return 'VENCIDO'
    //   if (d >= 15) return 'POR VENCER'
    //   return 'EN PLAZO'
    // },
    estadoClase (f) {
      if (f.estado_pago === 'PAGADO') return 'badge-verde'

      const d = this.diasTranscurridos(f.fecha_emision)
      const plazo = Number(f.dias_pago || 15)
      const inicioAlerta = Math.floor(plazo / 2)

      if (d >= plazo) {
        return 'badge-rojo'
      }

      if (d >= inicioAlerta) {
        return 'badge-amarillo'
      }

      return 'badge-verde'
    },

    estadoTexto (f) {
      if (f.estado_pago === 'PAGADO') return 'PAGADO'

      const d = this.diasTranscurridos(f.fecha_emision)
      const plazo = Number(f.dias_pago || 15)
      const inicioAlerta = Math.floor(plazo / 2)

      if (d >= plazo) {
        return 'VENCIDO'
      }

      if (d >= inicioAlerta) {
        return 'POR VENCER'
      }

      return 'EN PLAZO'
    },
    async confirmarRecepcion(f) {

      if (!confirm('¿Confirma que recibió el pago?')) {
        return
      }

      try {

        await axios.put(
          `api/FacturacionRequerimientos/ConfirmarRecepcion/${f.id_facturacion}`
        )

        this.snackbar = {
          show: true,
          text: 'Recepción confirmada correctamente',
          color: 'success'
        }

        this.listarPostulaciones()

      } catch (error) {

        this.snackbar = {
          show: true,
          text: 'Error al confirmar recepción',
          color: 'error'
        }

      }
    },
  }
}
</script>

<style scoped>
.card {
  background: #fff;
  padding: 18px;
  border-radius: 6px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 14px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 14px;
  border-bottom: 1px solid #e5e7eb;
  vertical-align: top;
}

.factura-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 6px 0;
}

.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.badge-si {
  background: #bbf7d0;
  color: #166534;
}

.badge-evaluacion {
  background: #fef9c3;
  color: #854d0e;
}

.action-cell {
  text-align: center;
}

.text-muted {
  color: #9ca3af;
}

.req-title {
  font-size: 18px;
  font-weight: 700;
}

.req-subtitle {
  font-size: 14px;
  color: #6b7280;
}
.badge-verde {
  background: #BABB13;
  color: #fff;
}

.badge-amarillo {
  background: #FDB714;
  color: #000;
}

.badge-rojo {
  background: #C05026;
  color: #fff;
}
</style>
